import { isValid, rules } from '@/app/shared/utilities/validations.util';

export const getUser = (state, getters, rootState, rootGetters) => state.user;
export const isValidPhone = (state) => isValid(state.user.phone, rules.phone)